(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/init-scripts.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/init-scripts.js');
"use strict";


var _svs$content$image_v = svs.content.image_v2.helpers,
  multiImageStyleElement = _svs$content$image_v.multiImageStyleElement,
  setLazyConfig = _svs$content$image_v.setLazyConfig;

setLazyConfig();

var multiImageElements = document.querySelectorAll('[data-multi-image-id]');
multiImageElements.forEach(function (imageElement) {
  return multiImageStyleElement.setupForImageElement(imageElement);
});

 })(window);